import type { CSSProperties, ReactNode } from 'react';
import { colors } from './tokens';

type Tone = 'neutral' | 'accent' | 'good' | 'warn' | 'bad';
type Size = 'sm' | 'md';

const tones: Record<Tone, { bg: string; fg: string; border?: string }> = {
  neutral: { bg: colors.surface2, fg: colors.ink3, border: colors.line2 },
  accent: { bg: colors.accentSoft, fg: colors.accent },
  good: { bg: colors.goodSoft, fg: colors.good },
  warn: { bg: colors.warnSoft, fg: colors.warn },
  bad: { bg: colors.badSoft, fg: colors.bad },
};

const sizes: Record<Size, { padding: string; fontSize: number; letter: string }> = {
  sm: { padding: '2px 7px', fontSize: 9.5, letter: '0.12em' },
  md: { padding: '3px 9px', fontSize: 10.5, letter: '0.1em' },
};

type Props = {
  tone?: Tone;
  size?: Size;
  children: ReactNode;
  style?: CSSProperties;
};

export function Pill({ tone = 'neutral', size = 'sm', children, style }: Props) {
  const t = tones[tone];
  const s = sizes[size];
  return (
    <span
      style={{
        fontVariantNumeric: 'tabular-nums',
        fontSize: s.fontSize,
        letterSpacing: s.letter,
        textTransform: 'uppercase',
        background: t.bg,
        color: t.fg,
        border: t.border ? `1px solid ${t.border}` : '1px solid transparent',
        padding: s.padding,
        borderRadius: 4,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
